import React from "react";
import {
  RadioGroup,
  Grid,
  TextField,
  Button,
  withStyles,
  FormControlLabel,
  Radio,
  MenuItem,
  FormGroup,
  Checkbox,
  InputLabel,
  Select,
  Input,
  FormControl
} from "material-ui";
import Icon from "material-ui/Icon";
import Title from "../../ui/title";
import Content from "../../ui/content";
import styles from "./styles";
import ConfirmDialog from "../../common/dialog/confirm";
import { withRouter } from "react-router-dom";
import Back from "../../ui/back";
import BackCheck from "../../ui/backCheck";
import { validateFormData } from "../../../common/formtool";
import { ToInt, ToReal, ToDuration } from "../../../common/datatypetool";
import { MaxThroughPutEnum } from "./maxthroughputenum";

class MaxThroughPut extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: 0,
      organisationid: 0,
      linkSpeed: [],
      testTemplate: [],
      autoAdjust: true,
      passFailLimit: [],
      frameLossLimit: [],
      countValue: 0,
      percentValue: 0,
      duration: 10,
      hours: "00",
      minutes: "00",
      seconds: "00",
      propagationDelay: 10,
      jitterLimit: 10,
      isChanged: false,
      showConfirmBack: false,
      frameLossDisable: true,
      errors: {},
      countDefaultValue: 0,
      percentDefaultValue: 0.0,
      frameLossDefaultValue: 0,
      propagationDelayDefault: 0,
      jitterLimitDefault: 0,
      durationDisable: false,
      isRestore: false,
      showRestoreConfirm: false,
      isMaxthroughputUpdated: false
    };
  }

  updateMaxThroughPut = maxThroughPut => {
    // durationn = this.mapEnumValue(
    //   this.mapEnumValue(maxThroughPut.losslimit, "losslimit").value,
    //   "duration"
    // );

    //this.splitDuration(maxThroughPut.duration);
    this.setState({
      linkSpeed: this.mapEnumValue(0, "linkspeed"),
      testTemplate: this.mapEnumValue(
        maxThroughPut.testtemplate,
        "testtemplate"
      ),
      passFailLimit: this.mapEnumValue(maxThroughPut.losslimit < 8 ? 9 : maxThroughPut.losslimit, "losslimit"),
      frameLossLimit: this.mapEnumValue(
        maxThroughPut.framelosslimit,
        "framelosslimit"
      ),

      countValue: parseInt(maxThroughPut.count),
      percentValue: Number.isInteger(maxThroughPut.percent)
        ? parseInt(maxThroughPut.percent)
        : parseFloat(maxThroughPut.percent),
      propagationDelay:
        this.mapEnumValue(maxThroughPut.losslimit < 8 ? 8 : maxThroughPut.losslimit, "losslimit")[0].key == 8
          ? Number.isInteger(maxThroughPut.propagationdelaylimit)
            ? maxThroughPut.propagationdelaylimit
            : parseFloat(maxThroughPut.propagationdelaylimit)
          : 300,
      jitterLimit:
        this.mapEnumValue(maxThroughPut.losslimit < 8 ? 9 : maxThroughPut.losslimit, "losslimit")[0].key == 8
          ? Number.isInteger(maxThroughPut.jitterlimit)
            ? maxThroughPut.jitterlimit
            : parseFloat(maxThroughPut.jitterlimit)
          : 15,
      autoAdjust: true, //maxThroughPut.autoadjustspeed,
      countDefaultValue: parseInt(maxThroughPut.count),
      percentDefaultValue: Number.isInteger(maxThroughPut.percent)
        ? parseInt(maxThroughPut.percent)
        : parseFloat(maxThroughPut.percent),
      frameLossDefaultValue: this.mapEnumValue(
        maxThroughPut.framelosslimit,
        "framelosslimit"
      ),
      id: maxThroughPut.id,
      organisationid: maxThroughPut.organisationid,
      propagationDelayDefault: Number.isInteger(
        maxThroughPut.propagationdelaylimit
      )
        ? maxThroughPut.propagationdelaylimit
        : parseFloat(maxThroughPut.propagationdelaylimit),
      jitterLimitDefault: Number.isInteger(maxThroughPut.jitterlimit)
        ? maxThroughPut.jitterlimit
        : parseFloat(maxThroughPut.jitterlimit),
      durationDisable:
        this.mapEnumValue(maxThroughPut.losslimit < 8 ? 9 : maxThroughPut.losslimit, "losslimit")[0].key == 8
          ? false
          : true,
      frameLossDisable:
        this.mapEnumValue(maxThroughPut.losslimit < 8 ? 9 : maxThroughPut.losslimit, "losslimit")[0].key == 8
          ? false
          : true
    });
    this.setState({
      duration: this.durationMapping(
        this.mapEnumValue(maxThroughPut.losslimit < 8 ? 9 : maxThroughPut.losslimit, "losslimit")[0].key,
        maxThroughPut
      )
    });
    this.splitDuration(
      this.durationMapping(maxThroughPut.losslimit < 8 ? 9 : maxThroughPut.losslimit, maxThroughPut)
    );
  };

  toFixed = (e, numberOfDigit, newErrors) => {
    let value = ToReal(e.target.value);
    value = value.split(".");
    if (value.length > 2) {
      this.setState({ errors: { [e.target.name]: {} } });
    } else if (value.length === 1) {
      this.setState({
        [e.target.name]: value[0],
        isChanged: true,
        isRestore: false,
        errors: newErrors
      });
    } else {
      if (value[1].length > numberOfDigit) {
        e.preventDefault();
      } else {
        this.setState({
          [e.target.name]: ToReal(e.target.value),
          isChanged: true,
          isRestore: false,
          errors: newErrors
        });
      }
    }
  };

  durationMapping = (passFailLimitValue, mt = null) => {
    switch (passFailLimitValue) {
      case 0:
      case 1:
      case 3:
      case 4:
      case 5:
      case 6:
      case 7:
      case 9:
      case 10: {
        return MaxThroughPutEnum.DurationMap.filter(
          durationObj => durationObj.key === parseInt(passFailLimitValue)
        )[0].value;
      }
      case 2: {
        if (
          (this.state.linkSpeed &&
            this.state.linkSpeed[0] &&
            this.state.linkSpeed[0].key === 3) ||
          (mt && mt.linkSpeed === 3)
        ) {
          return 400;
        } else {
          return 200;
        }
      }
      case 8: {
        return mt && mt.duration ? mt.duration : this.state.duration;
      }
    }
  };

  splitDuration = duration => {
    let hours = 0,
      minutes = 0,
      seconds = 0;
    if (parseInt(duration) >= 3600) {
      hours = parseInt(duration / 3600);
      duration = parseInt(duration % 3600);
    }
    if (parseInt(duration) >= 60) {
      minutes = parseInt(duration / 60);
      duration = parseInt(duration % 60);
    }
    this.setState({
      hours: ToDuration(hours + ""),
      minutes: ToDuration(minutes + ""),
      seconds: ToDuration(duration + ""),
      isRestore: false
    });
  };

  mapEnumValue = (key, type) => {
    switch (type.toLowerCase()) {
      case "linkspeed": {
        return MaxThroughPutEnum.LinkSpeed.filter(
          linkSpeed => linkSpeed.key === parseInt(key)
        );
      }
      case "losslimit": {
        if (key == 8) {
          this.setState({ frameLossDisable: false });
        }
        return MaxThroughPutEnum.PassFailLimit.filter(
          pflimit => pflimit.key === parseInt(key)
        );
      }
      case "framelosslimit": {
        return MaxThroughPutEnum.FrameLossLimit.filter(
          fllimit => fllimit.key === parseInt(key)
        );
      }
      case "testtemplate": {
        return MaxThroughPutEnum.TestTemplate.filter(
          testTemp => testTemp.key === parseInt(key)
        );
      }
      case "duration": {
        return MaxThroughPutEnum.DurationMap.filter(
          duration => duration.key === parseInt(key)
        );
      }
    }
  };

  hideBackConfirmModal = () => {
    this.setState({
      showConfirmBack: false
    });
  };

  onBackYesClick = () => {
    this.setState({
      showConfirmBack: false
    });
    this.onMaxThroughPutSave();
  };

  onBackNoClick = () => {
    this.props.history.push("/subtestsettings");
  };

  validateDefaultValue = (e, percentOnly = false) => {
    const {
      countDefaultValue,
      percentDefaultValue,
      frameLossDefaultValue,
      propagationDelayDefault,
      jitterLimitDefault,
      errors
    } = this.state;
    let updatedErrors = errors;
    const { translate } = this.props;
    let validationObj = {
      propagationDelay: {
        required: {
          required: translate("formfield_error_general_required")
        },
        range: {
          minValue: 0.001,
          maxValue: 1000.0,
          message: translate("formfield_error_general_required")
        }
      },
      jitterLimit: {
        required: {
          required: translate("formfield_error_general_required")
        },
        range: {
          minValue: 0.000001,
          maxValue: 500.0,
          message: translate("formfield_error_general_required")
        }
      },
      countValue: {
        required: {
          required: translate("formfield_error_general_required")
        },
        range: {
          minValue: 0,
          maxValue: 9999,
          message: translate("formfield_error_general_required")
        },
        type: {
          value: "numeric",
          message: translate("formfield_error_general_required")
        }
      },
      percentValue: {
        required: {
          required: translate("formfield_error_general_required")
        },
        range: {
          minValue: 0.00001,
          maxValue: 10.0,
          message: translate("formfield_error_general_required")
        }
      }
    };
    let validationErrors = validateFormData({ ...this.state }, validationObj);
    let limit = this.mapEnumValue(e.target.value, "losslimit");
    if (Object.keys(validationErrors).length) {
      if (!percentOnly) {
        delete updatedErrors.jitterLimit;
        delete updatedErrors.propagationDelay;
        delete updatedErrors.countValue;
        delete updatedErrors.percentValue;
        if (validationErrors.countValue) {
          this.setState({
            passFailLimit: limit,
            isChanged: true,
            frameLossDisable: true,
            countValue: countDefaultValue
          });
        }
        if (validationErrors.percentValue || this.state.percentValue === "") {
          this.setState({
            passFailLimit: limit,
            isChanged: true,
            frameLossDisable: true,
            percentValue: percentDefaultValue
          });
        }
        if (validationErrors.propagationDelay) {
          this.setState({
            passFailLimit: limit,
            isChanged: true,
            frameLossDisable: true,
            propagationDelay: propagationDelayDefault
          });
        }
        if (validationErrors.jitterLimit) {
          this.setState({
            passFailLimit: limit,
            isChanged: true,
            frameLossDisable: true,
            jitterLimit: jitterLimitDefault
          });
        } else {
          this.setState({
            passFailLimit: limit,
            isChanged: true,
            frameLossDisable: true
          });
        }
      } else {
        delete updatedErrors.percentValue;
        delete updatedErrors.countValue;
        if (validationErrors.percentValue || this.state.percentValue === "") {
          this.setState({ isChanged: true, percentValue: percentDefaultValue });
        } else if (validationErrors.countValue) {
          this.setState({ isChanged: true, countValue: countDefaultValue });
        }
      }
    } else if (limit && limit.length) {
      this.setState({
        passFailLimit: limit,
        isChanged: true,
        frameLossDisable: true
      });
    }
  };

  onChange = e => {
    const { duration, autoAdjust, errors, percentDefaultValue } = this.state;
    let newErrors = {};
    switch (e.target.name) {
      case "linkSpeed":
        this.setState({
          linkSpeed: this.mapEnumValue(e.target.value, "linkspeed"),
          isChanged: true,
          isRestore: false
        });
        if (this.state.passFailLimit[0].key === 2) {
          if (e.target.value === 3) {
            this.setState({
              duration: 400
            });
            this.splitDuration(400);
          } else {
            this.setState({
              duration: 200
            });
            this.splitDuration(200);
          }
        }
        break;
      case "testTemplate":
        this.setState({
          testTemplate: this.mapEnumValue(e.target.value, "testtemplate"),
          isChanged: true,
          isRestore: false
        });
        break;
      case "frameLossLimit":
        this.setState({
          frameLossLimit: this.mapEnumValue(e.target.value, "framelosslimit"),
          isChanged: true,
          isRestore: false
        });
        break;
      case "passFailLimit":
        if (e.target.value == 8) {
          this.setState({
            passFailLimit: this.mapEnumValue(e.target.value, "losslimit"),
            isChanged: true,
            isRestore: false,
            frameLossDisable: false,
            durationDisable: false,
            jitterLimit: Number.isInteger(this.props.maxThroughPut.jitterlimit)
              ? this.props.maxThroughPut.jitterlimit
              : parseFloat(this.props.maxThroughPut.jitterlimit),

            propagationDelay: Number.isInteger(
              this.props.maxThroughPut.propagationdelaylimit
            )
              ? this.props.maxThroughPut.propagationdelaylimit
              : parseFloat(this.props.maxThroughPut.propagationdelaylimit),
            duration: this.mapEnumValue(e.target.value, "losslimit")[0].key
          });
          this.splitDuration(
            this.durationMapping(e.target.value, this.props.maxThroughPut)
          );
        } else {
          errors.duration = "";
          this.setState({
            isChanged: true,
            isRestore: false,
            durationDisable: true,
            jitterLimit: 15,
            propagationDelay: 300,
            duration: this.mapEnumValue(e.target.value, "losslimit")[0].key,
            errors
          });
          this.validateDefaultValue(e);
          this.splitDuration(
            this.durationMapping(
              this.mapEnumValue(e.target.value, "losslimit")[0].key
            )
          );
        }
        break;
      case "autoAdjust":
        this.setState({
          [e.target.name]: !autoAdjust,
          isChanged: true,
          isRestore: false
        });
        break;
      case "Count":
      case "Percent %":
        newErrors = errors;
        delete newErrors[e.target.name];
        this.validateDefaultValue(e, true);
        if (e.target.name === "Count") {
          this.setState({
            frameLossLimit: this.updateFramLossLimit(e.target.name),
            isChanged: true,
            isRestore: false,
            errors: newErrors
          });
        } else {
          this.setState({
            frameLossLimit: this.updateFramLossLimit(e.target.name),
            isChanged: true,
            isRestore: false,
            errors: newErrors
          });
        }
        break;
      case "countValue":
        let onlyInterger = ToInt(e.target.value);
        this.setState({
          [e.target.name]: onlyInterger,
          isChanged: true,
          isRestore: false,
          errors: newErrors
        });
        break;
      case "percentValue":
        delete newErrors[e.target.name];
        this.toFixed(e, 5, newErrors);
        break;
      case "jitterLimit":
        delete newErrors[e.target.name];
        this.toFixed(e, 6, newErrors);
        break;
      default:
        newErrors = errors;
        delete newErrors[e.target.name];
        this.setState({
          [e.target.name]: ToReal(e.target.value),
          isChanged: true,
          isRestore: false,
          errors: newErrors
        });
        break;
    }
  };

  updateFramLossLimit = value => {
    return MaxThroughPutEnum.FrameLossLimit.filter(
      freameLossLimit => freameLossLimit.value === value
    );
  };

  onBackClick = () => {
    if (this.state.isChanged) {
      this.setState({
        showConfirmBack: true
      });
    }
  };

  onMaxThroughPutSave = () => {
    const {
      frameLossLimit,
      hours,
      minutes,
      seconds,
      countValue,
      passFailLimit,
      isRestore
    } = this.state;
    const { translate, error, isTestEdit } = this.props;
    let errors;
    let validationObj = {
      duration: {
        required: {
          required: translate("formfield_error_general_required")
        },
        range: {
          minValue: 10,
          maxValue: 30,
          message: translate("formfield_error_general_required")
        }
      },
      propagationDelay: {
        required: {
          required: translate("formfield_error_general_required")
        },
        range: {
          minValue: 0.001,
          maxValue: 1000.0,
          message: translate("formfield_error_general_required")
        }
      },
      jitterLimit: {
        required: {
          required: translate("formfield_error_general_required")
        },
        range: {
          minValue: 0.000001,
          maxValue: 500.0,
          message: translate("formfield_error_general_required")
        }
      }
    };

    let duration =
      parseInt(hours) * 3600 + parseInt(minutes) * 60 + parseInt(seconds);
    if (
      (frameLossLimit && frameLossLimit.length && frameLossLimit[0].value) ===
      "Count"
    ) {
      validationObj["countValue"] = {
        required: {
          required: translate("formfield_error_general_required")
        },
        range: {
          minValue: 0,
          maxValue: 9999,
          message: translate("formfield_error_general_required")
        },
        type: {
          value: "numeric",
          message: translate("formfield_error_general_required")
        }
      };
      errors = validateFormData(
        { ...this.state, duration: duration },
        validationObj
      );
    } else {
      validationObj["percentValue"] = {
        required: {
          required: translate("formfield_error_general_required")
        },
        range: {
          minValue: 0.00001,
          maxValue: 10.0,
          message: translate("formfield_error_general_required")
        }
      };
      errors = validateFormData(
        { ...this.state, duration: duration },
        validationObj
      );
    }
    if (duration == 0 && errors.duration == undefined) {
      errors.duration = "Required";
    }
    const missingFieldName = Object.keys(errors)[0];
    if (missingFieldName) {
      const textField = document.getElementsByName(missingFieldName)[0];
      textField && textField.focus();
    }
    if (passFailLimit[0].key != 8) {
      delete errors["duration"];
    }
    if (this.state.propagationDelay === 0) {
      errors["propagationDelay"] = {};
    }
    if (this.state.jitterLimit === 0) {
      errors["jitterLimit"] = {};
    }
    if (Object.keys(errors).length) {
      this.setState({ errors: errors });
    } else {
      const {
        linkSpeed,
        passFailLimit,
        frameLossLimit,
        countValue,
        percentValue,
        propagationDelay,
        jitterLimit,
        testTemplate,
        autoAdjust,
        id,
        organisationid
      } = this.state;
      let payload = {
        id: id,
        organisationid: organisationid,
        linkspeed: 0, //parseInt(linkSpeed[0].key),
        duration: parseInt(duration),
        losslimit: parseInt(passFailLimit[0].key),
        framelosslimit: parseInt(frameLossLimit[0].key),
        count: countValue === "" ? 0 : parseInt(countValue),
        percent: percentValue === "" ? 0 : parseFloat(percentValue),
        propagationdelaylimit: parseFloat(propagationDelay),
        jitterlimit: parseFloat(jitterLimit),
        testtemplate: parseInt(testTemplate[0].key),
        autoadjustspeed: true // autoAdjust
      };
      if (!error) {
        this.setState({
          isChanged: false,
          errors: {},
          countDefaultValue: countValue,
          percentDefaultValue: percentValue,
          frameLossDefaultValue: frameLossLimit,
          propagationDelayDefault: propagationDelay,
          jitterLimitDefault: jitterLimit
        });
      } else {
        this.setState({ isChanged: false, errors: {} });
      }

      //this.props.updateMaxThroughPut(payload);

      if (isTestEdit) {
        this.props.updateMaxThroughPut(this.props.selectedTest, payload);
        this.props.handleClose();
      } else {
        this.props.updateMaxThroughPut(payload);
      }
      if (isRestore) {
        this.props.deleteDefaultSubtests(this.props.selectedTest);
      }
    }
  };

  onResetDetails = () => {
    this.setState({
      showRestoreConfirm: true
    });
  };
  onRestoreConfirm = () => {
    //this.props.updateUpTime(this.props.selectedTest, this.props.upTime);
    this.updateMaxThroughPut(this.props.maxThroughPut);
    this.setState({
      showRestoreConfirm: false,
      isChanged: true,
      isRestore: true
    });
  };

  hideRestoreConfirmModal = () => {
    this.setState({
      showRestoreConfirm: false
    });
  };

  renderValue = selectedValue => {
    return selectedValue && selectedValue.length && selectedValue[0].value;
  };

  onKeyDown = event => {
    if (event.key === ".") {
      event.preventDefault();
    }
  };

  onInput = event => {
    let additionMinutes = 0,
      additionalHours = 0;
    let newErrors = this.state.errors;
    delete newErrors["duration"];
    let onlyInteger = ToDuration(event.target.value);
    const { hours, minutes, seconds } = this.state;

    if (event.target.name === "seconds" && parseInt(onlyInteger) > 59) {
      additionMinutes = parseInt(onlyInteger / 60);
      onlyInteger = parseInt(onlyInteger % 60);
      additionMinutes = ToDuration(
        parseInt(minutes) + parseInt(additionMinutes) + ""
      );
      if (parseInt(additionMinutes) > 59) {
        additionalHours = parseInt(additionMinutes / 60);
        additionMinutes = ToDuration(parseInt(additionMinutes % 60) + "");
      }
      additionalHours = ToDuration(
        parseInt(hours) + parseInt(additionalHours) + ""
      );
      this.setState({
        [event.target.name]: ToDuration(onlyInteger + ""),
        minutes: additionMinutes,
        hours: additionalHours,
        isChanged: true,
        isRestore: false,
        errors: newErrors
      });
    } else if (event.target.name === "minutes" && parseInt(onlyInteger) > 59) {
      additionalHours = parseInt(onlyInteger / 60);
      onlyInteger = parseInt(onlyInteger % 60);
      additionalHours = ToDuration(
        parseInt(hours) + parseInt(additionalHours) + ""
      );
      this.setState({
        [event.target.name]: ToDuration(onlyInteger + ""),
        hours: additionalHours,
        isChanged: true,
        isRestore: false,
        errors: newErrors
      });
    } else {
      this.setState({
        [event.target.name]: onlyInteger + "",
        isChanged: true,
        isRestore: false,
        errors: newErrors
      });
    }
  };

  render() {
    const {
      linkSpeed,
      testTemplate,
      autoAdjust,
      passFailLimit,
      frameLossLimit,
      countValue,
      percentValue,
      propagationDelay,
      hours,
      jitterLimit,
      isChanged,
      frameLossDisable,
      errors,
      minutes,
      seconds,
      durationDisable,
      isRestore
    } = this.state;
    const {
      translate,
      classes,
      selectedTest,
      isTestEdit,
      maxThroughPut,
      maxthroughputDetails,
      testEdit,
      modified
    } = this.props;
    let countDisable =
      frameLossDisable ||
      (frameLossLimit &&
        frameLossLimit.length &&
        frameLossLimit[0].value !== "Count"
        ? true
        : false);
    let percentDisable =
      frameLossDisable ||
      (frameLossLimit &&
        frameLossLimit.length &&
        frameLossLimit[0].value === "Count"
        ? true
        : false);

    return (
      <div style={{marginTop: isTestEdit ? "15px" : "215px"}}>
        {!isTestEdit && (
          <Title
            back={
              !isChanged && (
                <Back
                  link={"/subtestsettings"}
                  title={translate("general_sub_test_settings")}
                />
              )
            }
            backCheck={
              isChanged && (
                <BackCheck
                  toCheck={this.onBackClick}
                  title={translate("general_sub_test_settings")}
                />
              )
            }
            title={translate("sub_test_empty_target_search_t3", {
              name: "Max Throughput"
            })}
          />
        )}
        <Content translate={translate}>
          {maxThroughPut && (linkSpeed && linkSpeed.length > 0) && (
            <Grid container>
              <Grid item xs={!isTestEdit ? 2 : 0}></Grid>
              <Grid item xs={!isTestEdit ? 8 : 10}>
                {false && <FormControl fullWidth margin="normal" error={false}>
                  <InputLabel id="link-speed">
                    {translate("sub_test_link_speed")}
                  </InputLabel>
                  <Select
                    labelId="link-speed"
                    name="linkSpeed"
                    renderValue={() => this.renderValue(linkSpeed)}
                    onChange={this.onChange}
                    input={<Input value={() => this.renderValue(linkSpeed)} />}
                    autoWidth={false}
                  >
                    {MaxThroughPutEnum.LinkSpeed.map(linkSpeed => {
                      return (
                        <MenuItem key={linkSpeed.value} value={linkSpeed.key}>
                          {linkSpeed.value}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>}
                <FormControl fullWidth margin="normal" error={false}>
                  <InputLabel id="test-template">
                    {translate("sub_test_test_template")}
                  </InputLabel>
                  <Select
                    labelId="test-template"
                    name="testTemplate"
                    renderValue={() => this.renderValue(testTemplate)}
                    onChange={this.onChange}
                    input={
                      <Input value={() => this.renderValue(testTemplate)} />
                    }
                    autoWidth={false}
                  >
                    {MaxThroughPutEnum.TestTemplate.map(testTemp => {
                      return (
                        <MenuItem key={testTemp.value} value={testTemp.key}>
                          {testTemp.value}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
                {false && <FormControl fullWidth margin="normal" error={false}>
                  <FormGroup row>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={autoAdjust}
                          onChange={this.onChange}
                          name="autoAdjust"
                        />
                      }
                      label={<b>{translate("sub_test_auto_adjust_speed")}</b>}
                    />
                  </FormGroup>
                </FormControl>}
                <FormControl fullWidth margin="normal" error={false}>
                  <InputLabel id="pass-fail_limit">
                    {translate("sub_test_pass_fail_limit")}
                  </InputLabel>
                  <Select
                    labelId="pass-fail_limit"
                    name="passFailLimit"
                    renderValue={() => this.renderValue(passFailLimit)}
                    onChange={this.onChange}
                    input={
                      <Input value={() => this.renderValue(passFailLimit)} />
                    }
                    autoWidth={false}
                  >
                    {MaxThroughPutEnum.PassFailLimit.map(pflimit => {
                      return (
                        <MenuItem key={pflimit.value} value={pflimit.key}>
                          {pflimit.value}
                        </MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
                {!frameLossDisable && <div
                  style={{
                    alignContent: "space-between",
                    alignItems: "stretch"
                  }}
                >
                  <br />
                  <InputLabel
                    htmlFor="sub_test_frame_loss_limit"
                    style={{ fontSize: "14px" }}
                  >
                    {translate("sub_test_frame_loss_limit")}
                  </InputLabel>
                  <RadioGroup
                    row={true}
                    aria-label=""
                    name="frameLossLimit"
                    value={frameLossLimit}
                    onChange={this.onChange}
                    disabled={frameLossDisable}
                  >
                    <Grid container>
                      <Grid item xs={6}>
                        <FormControlLabel
                          control={
                            <Radio
                              checked={
                                (frameLossLimit &&
                                  frameLossLimit.length &&
                                  frameLossLimit[0].value) === "Count"
                                  ? true
                                  : false
                              }
                              onChange={this.onChange}
                              name="Count"
                              disabled={frameLossDisable}
                            />
                          }
                          label={
                            frameLossDisable || countDisable ? (
                              translate("subset_ping_count")
                            ) : (
                                <b>{translate("subset_ping_count")}</b>
                              )
                          }
                        />
                        <br />
                        <TextField
                          className={classes.textField}
                          error={errors.countValue}
                          name="countValue"
                          margin="normal"
                          value={countValue}
                          onChange={this.onChange}
                          disabled={countDisable}
                          fullWidth
                          helperText={
                            errors.countValue
                              ? translate("subtest_number_range", {
                                start: 0,
                                end: 9999
                              })
                              : ""
                          }
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <FormControlLabel
                          value={"percent %"}
                          control={
                            <Radio
                              checked={
                                (frameLossLimit &&
                                  frameLossLimit.length &&
                                  frameLossLimit[0].value) !== "Count"
                                  ? true
                                  : false
                              }
                              onChange={this.onChange}
                              name="Percent %"
                              disabled={frameLossDisable}
                            />
                          }
                          label={
                            frameLossDisable || percentDisable ? (
                              translate("sub_test_percent")
                            ) : (
                                <b>{translate("sub_test_percent")}</b>
                              )
                          }
                        />
                        <br />
                        <TextField
                          className={classes.textField}
                          error={errors.percentValue}
                          name="percentValue"
                          margin="normal"
                          value={percentValue}
                          onChange={this.onChange}
                          disabled={percentDisable}
                          fullWidth
                          helperText={
                            errors.percentValue
                              ? translate("subtest_number_range", {
                                start: 0.00001,
                                end: (10.0).toFixed(4)
                              })
                              : ""
                          }
                        />
                      </Grid>
                    </Grid>
                  </RadioGroup>
                </div>}
                {!durationDisable &&
                  <div>
                    <div>
                      <br />
                      <InputLabel
                        htmlFor="sub_test_duration"
                        style={{ fontSize: "14px", height: "5" }}
                      >
                        {translate("uptime_duration")}
                      </InputLabel>
                    </div>
                    <TextField
                      type="number"
                      InputProps={{
                        inputProps: {
                          min: 0,
                          max: 23,
                          onKeyDown: this.onKeyDown,
                          onInput: this.onInput
                        }
                      }}
                      style={{ width: 40 }}
                      className={classes.textField}
                      error={errors.duration}
                      name="hours"
                      margin="normal"
                      value={hours}
                      disabled={durationDisable}
                    />
                    {" : "}
                    <TextField
                      type="number"
                      InputProps={{
                        inputProps: {
                          min: 0,
                          max: 59,
                          onKeyDown: this.onKeyDown,
                          onInput: this.onInput
                        }
                      }}
                      style={{ width: 40 }}
                      className={classes.textField}
                      error={errors.duration}
                      name="minutes"
                      margin="normal"
                      value={minutes}
                      disabled={durationDisable}
                    />
                    {" : "}
                    <TextField
                      type="number"
                      InputProps={{
                        inputProps: {
                          min: 0,
                          max: 59,
                          step: 1,
                          onKeyDown: this.onKeyDown,
                          onInput: this.onInput
                        }
                      }}
                      style={{ width: 40 }}
                      className={classes.textField}
                      error={errors.duration}
                      name="seconds"
                      margin="normal"
                      value={seconds}
                      disabled={durationDisable}
                    />
                    <div>
                      {errors.duration ? (
                        <InputLabel
                          htmlFor="sub_test_duration"
                          style={{
                            fontSize: "13px",
                            height: "5",
                            color: "red"
                          }}
                        >
                          {translate("subtest_number_range", {
                            start: "00:00:10",
                            end: "00:00:30"
                          })}
                        </InputLabel>
                      ) : null}
                    </div>
                  </div>
                }
                <br />
                {!frameLossDisable && <TextField
                  style={{ width: 270, whiteSpace: 'nowrap' }}
                  className={classes.textField}
                  error={errors.propagationDelay}
                  name="propagationDelay"
                  label={translate("sub_test_propagation_delay_limit")}
                  margin="normal"
                  value={propagationDelay}
                  onChange={this.onChange}
                  disabled={frameLossDisable}
                  helperText={
                    errors.propagationDelay
                      ? translate("subtest_number_range", {
                        start: 0.001,
                        end: (1000.0).toFixed(1)
                      })
                      : ""
                  }
                />}
                <br />
                {!frameLossDisable && <TextField
                  style={{ width: 270 }}
                  className={classes.textField}
                  error={errors.jitterLimit}
                  name="jitterLimit"
                  label={translate("sub_test_jitter_limit")}
                  margin="normal"
                  value={jitterLimit}
                  onChange={this.onChange}
                  disabled={frameLossDisable}
                  helperText={
                    errors.jitterLimit
                      ? translate("subtest_number_range", {
                        start: 0.000001,
                        end: (500.0).toFixed(1)
                      })
                      : ""
                  }
                />}
                {!isTestEdit && (
                  <div align="right">
                    <Button
                      className={classes.saveTarget}
                      disabled={!isChanged}
                      color="accent"
                      raised
                      mini
                      onClick={this.onMaxThroughPutSave}
                    >
                      {translate("sub_set_ping_save_target")}
                    </Button>
                  </div>
                )}
              </Grid>
              <Grid item xs={!isTestEdit ? 2 : 0}></Grid>
            </Grid>
          )}
          {!isTestEdit && (
            <ConfirmDialog
              open={this.state.showConfirmBack}
              title={translate("sub_test_ping_delete_confirm_title", {
                name: "Max ThroughPut"
              })}
              contentText={translate("sub_test_go_back_confirm_text")}
              cancelText={translate("general_cancel")}
              onCancel={this.hideBackConfirmModal}
              yesText={translate("back_btn_yes")}
              noText={translate("back_btn_no")}
              backText={translate("back_btn_go_back")}
              onYes={this.onBackYesClick}
              onNo={this.onBackNoClick}
              onBack={this.hideBackConfirmModal}
            />
          )}
          {isTestEdit && (
            <ConfirmDialog
              open={this.state.showRestoreConfirm}
              title={testEdit ? translate("test_edit_title") : translate("test_add")}
              contentText={translate("restore_go_back_confirm_text")}
              contentSecondaryText={translate("general_confirmation_help_2")}
              okText={translate("general_confirm")}
              cancelText={translate("general_cancel")}
              onOk={this.onRestoreConfirm}
              onCancel={this.hideRestoreConfirmModal}
            />
          )}
          {isTestEdit && (
            <ConfirmDialog
              open={this.props.showTestCreationCancelConfirmation}
              title={testEdit ? translate("test_edit_title") : translate("test_add")}
              contentText={translate("st_test_go_back_confirm_text")}
              contentSecondaryText={translate("general_confirmation_help_2")}
              okText={translate("general_confirm")}
              cancelText={translate("general_cancel")}
              onOk={this.props.onTestCreationCancelConfirm}
              onCancel={this.props.hideTestCreationCancelConfirm}
            />
          )}
        </Content>
        {isTestEdit && maxThroughPut && (linkSpeed && linkSpeed.length > 0) && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between"
            }}
          >
            <div style={{ display: "inline-block", marginLeft: "20px" }}>
              {maxthroughputDetails && !testEdit ? (
                <Button
                  disabled={isRestore}
                  color="primary"
                  onClick={() => this.onResetDetails()}
                  className={classes.restoreButton}
                >
                  <Icon> restore </Icon> {translate("restore_default_settings")}
                </Button>
              ) : testEdit && modified ? (
                <Button
                  disabled={isRestore}
                  color="primary"
                  onClick={() => this.onResetDetails()}
                  className={classes.restoreButton}
                >
                  <Icon> restore </Icon> {translate("restore_default_settings")}
                </Button>
              ) : null}
            </div>
            <div style={{ display: "inline-block", marginRight: "20px" }}>
              <Button
                disabled={!isChanged}
                color="accent"
                raised
                onClick={() => this.onMaxThroughPutSave()}
                className={classes.saveTarget}
              >
                {translate("general_continue")}
              </Button>
            </div>
          </div>
        )}
      </div>
    );
  }

  // component life cycles
  componentWillMount() {
    const { getMaxThroughPut } = this.props;
    getMaxThroughPut();
  }

  componentWillReceiveProps(nextProps) {
    const { maxThroughPut, isTestEdit, maxthroughputDetails } = nextProps;
    if (isTestEdit && !maxthroughputDetails) {
      if (maxThroughPut && maxThroughPut != this.props.maxThroughPut) {
        this.updateMaxThroughPut(maxThroughPut);
      }
    } else if (isTestEdit && maxthroughputDetails) {
      if (
        (maxthroughputDetails &&
          this.props.maxthroughputDetails != maxthroughputDetails) ||
        !this.state.isMaxthroughputUpdated
      ) {
        this.updateMaxThroughPut(maxthroughputDetails);
        this.setState({ isMaxthroughputUpdated: true });
      }
    } else {
      if (maxThroughPut && maxThroughPut != this.props.maxThroughPut) {
        this.updateMaxThroughPut(maxThroughPut);
      }
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0)
  }

}

export default withRouter(withStyles(styles)(MaxThroughPut));
